import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { CopilotConfigOverride } from '../schemas/copilot-config-override.schema';

/**
 * Save a list of admin overrides for a configuration setting
 * @param configSettingsId Configuration Setting ID
 * @param configOverrides Configuration Overrides
 * @param alias Alias of account with configuration profile
 */
export function postConfigurationSettingsId(
  this: unknown,
  configSettingsId: number,
  configOverrides: CopilotConfigOverride[],
  alias?: string
) {
  const body: Record<string, unknown> = {
    configurations: configOverrides,
  };

  if (typeof alias === 'string') {
    body['alias'] = alias;
  }

  return withJwt(() =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).configurationSettingsUrl
        }/${encodeURIComponent(configSettingsId)}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...new AuthHeaders(), // Doesn't work with JWT for some reason
          },
          body: JSON.stringify(body),
        }
      )
    )
  ).pipe(ignoreData());
}
